export const DATA_INTELLIGENCE_STRINGS = {
    pageTitle: "Data Intelligence",
    apiKeyLabel: "Gemini API key (optional override)",
    apiKeyPlaceholder: "Leave blank to use the default key",
    apiKeyHelper: "Stored in this browser only if you choose to remember it.",
    rememberKeyLabel: "Remember override key on this device",
    schemaButton: "Refresh schema",
    showSchemaButton: "Show schema",
    hideSchemaButton: "Hide schema",
    questionLabel: "Ask a data question",
    questionPlaceholder: "e.g. How many events were created last month?",
    listenButton: "Listen",
    listeningButton: "Listening…",
    listenStopButton: "Stop",
    voiceUnsupported: "Voice input is not supported in this browser. Try Chrome or Edge.",
    voiceError: "Voice input failed. Check microphone permission.",
    generateSqlButton: "Generate SQL",
    generatingSqlButton: "Generating...",
    generateSqlAndRunButton: "Generate SQL & Run",
    generatingSqlAndRunButton: "Generating SQL & Running…",
    runQueryButton: "Run query",
    runningButton: "Running...",
    saveQueryButton: "Save query",
    explainResultButton: "Explain result",
    explainingResultButton: "Explaining…",
    sqlLabel: "SQL query",
    sqlPlaceholder: "Type or paste a SELECT query, or generate one from your question above.",
    resultsLabel: "Results",
    downloadCsvButton: "Download CSV",
    errorMissingApiKey: "Gemini is not configured. Add an API key and try again.",
    errorMissingQuestion: "Please enter a question.",
    errorSchemaFailed: "Failed to load schema.",
    errorRunFailed: "Query failed.",
    errorOnlySelect: "Only SELECT queries are allowed.",
    errorRateLimit: "Too many requests. Try again in a minute.",
    errorQueriesInProgress: "Too many queries in progress. Try again shortly.",
    errorQueryTimeout: "Query timed out. Try a simpler query or add a LIMIT.",
    errorSqlTooLong: "SQL is too long.",
    errorNotConfigured: "Data intelligence is not configured.",
    errorSchemaRateLimit: "Too many schema requests. Try again in a minute.",
    queryMayTakeUpTo: "Query may take up to 30 seconds.",
    loadingSchema: "Loading schema…",
};

const DATA_INTELLIGENCE_STORAGE_KEY = "admin_data_intelligence_llm_key";
export const getDataIntelligenceStorageKey = () => DATA_INTELLIGENCE_STORAGE_KEY;
